export default __webpack_public_path__ + "static/media/About-2.d193ca29.png";